exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.image[data-v-966bb9b0] {\n  width: 160px;\n  height: 160px;\n  overflow: hidden;\n}\n.image > img[data-v-966bb9b0] {\n    width: 160px;\n    max-height: 160px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-966bb9b0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/Event.vue
// module id = 1626
// module chunks = 0